import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Ring } from '@uiball/loaders';

interface VendorImportModalProps {
    isOpen: boolean;
}

const VendorImportModal: React.FC<VendorImportModalProps> = ({ isOpen }) => {
    return (
        <Modal 
            isOpen={isOpen} 
            centered 
            backdrop="static"
            keyboard={false}
            size="md"
        >
            <ModalBody className="text-center py-4">
                <h5 className="mb-4">Checking for existing payees</h5>
                <div className="mb-3">
                    <Ring color='#01aeb4' size={48} />
                </div>
                <p className="text-muted mb-0">
                    This should only take a few moments. If you have any existing payees, we will load them in 
                    to make entering Fund Requests a little easier.
                </p>
            </ModalBody>
        </Modal>
    );
};

export default VendorImportModal;